import React from 'react';
import { motion } from 'framer-motion';

const Grid = ({
  children,
  cols = { default: 1, md: 2, lg: 3 },
  gap = 8,
  className = "",
  staggerAnimation = true
}) => {
  const gridClasses = `grid gap-${gap} ${className}`;
  const colClasses = Object.entries(cols)
    .map(([breakpoint, colCount]) => 
      breakpoint === 'default' 
        ? `grid-cols-${colCount}` 
        : `${breakpoint}:grid-cols-${colCount}`
    )
    .join(' ');

  if (!staggerAnimation) {
    return (
      <div className={`${gridClasses} ${colClasses}`}>
        {children}
      </div>
    );
  }

  return (
    <div className={`${gridClasses} ${colClasses}`}>
      {React.Children.map(children, (child, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          viewport={{ once: true }}
        >
          {child}
        </motion.div>
      ))}
    </div>
  );
};

export default Grid;